import type { Router } from 'vue-router';
import { useAuthStore } from '../stores/auth.store';
import { isPromise } from '../../../utils';
import { storeToRefs } from 'pinia';
import type { AuthTokens } from '../models';

export const createAuthGuard = (router: Router, loginRouteName: string, homeRouteName = '') => {
  router.beforeEach(async (to) => {
    const authStore = useAuthStore();
    const { isAdmin, loggedIn } = storeToRefs(authStore);
    const routeQuery = to.query;

    if (authStore.initializingPromise && isPromise(authStore.initializingPromise) && to.name !== loginRouteName) {
      await authStore.initializingPromise;
    }

    // apply impersonation tokens if needed
    if (routeQuery.impersonate && routeQuery.impersonate === 'true') {
      const tokens: AuthTokens = {
        token: (routeQuery.access || '') as string,
        refreshToken: (routeQuery.refresh || '') as string
      };

      await authStore.impersonate(tokens);

      const homeRouteName = 'ownSampleUnitList';
      return { name: homeRouteName };
    }

    if (to.path === '/') {
      if (loggedIn.value) {
        const homeRouteName = isAdmin.value ? 'sampleUnitList' : 'ownSampleUnitList';

        return { name: homeRouteName };
      } else {
        return { name: loginRouteName };
      }
    }

    // check if authentication is required and user is logged in
    if (!to.meta.requiresAuth) return;

    if (to.name != loginRouteName && !authStore.loggedIn) {
      return { name: loginRouteName, query: { redirect: to.fullPath } };
    }

    // check permissions
    const routePermissions = to.meta.permission;
    if (!routePermissions || !routePermissions.length || authStore.hasPermission(routePermissions)) return;

    return { name: homeRouteName };
  });
};
